//Within this page we expose non secret constants for backend api routing.

export const BaseUrl = process.env.REACT_APP_BACKEND_URL

export const IdentityRoutes = {
    Login : "/account/login",
    LoginQueryParameters: {
        ReturnUrl: "returnUrl"
    },
    ChangeOrganisation : "/organisation/change"
}

export const ApiRoutes = {
    //Areas Base
    Areas: "api/assets/areas",

    //Machines Base
    Machines: "api/assets/machines",

    //Assets Base
    AssetsV1: "web/v1/assets",
    ImagesV1: "web/v1/images",

    //Templates (Asset Templates) - site-scoped by JWT siteId (Account Setup)
    TemplatesAssetsV1: "web/v1/templates/assets",
    //All templates across sites (SuperAdmin only, Administration)
    TemplatesAssetsAllV1: "web/v1/templates/assets/all",

    //Points Base
    Points: "api/assets/points",

    //Consumables Base
    Consumables: "api/assets/consumables",

    //Devices Base
    Devices: "api/devices",
    ManageDevices: "api/devices/admin",
    DevicesV1: "web/v1/devices",

    //Alerts
    Alerts: "web/v1/alerts",
    EndpointsV1: "web/v1/endpoints",


    //Notifications
    NotificationsSummary: "web/v1/notifications/summary",
    Notifications: "web/v1/notifications",

    //Endpoints
    Endpoints: "api/assets/endpoints",
    ManageEndpoints: "api/devices/endpoints/admin",
    SiteEndpointDevices: "api/devices/endpoints",
    EndpointsCompliance: "api/analysis/endpoint/compliance/",
    ImportEndpointCSV: "api/devices/endpoints/import/csv",

    //Reservoirs
    GreaseReservoirs: "api/assets/reservoirs/grease",
    GreaseReservoirsReset: "api/assets/reservoirs/grease/reset",
    GreaseReservoirsLink: "api/assets/reservoirs/grease/link",
    GreaseReservoirsLinkedPoints: "api/assets/reservoirs/grease/linkedPoints",
    GreaseReservoirsHistory: "api/assets/reservoirs/grease/history",

    //Requirements
    Requirement: "api/requirement/endpoint",

    //Analysis
    GreaseReservoirsAnalysis: "api/analysis/reservoir/grease",

    //Treelist
    TreeList: "api/assets/site/treelist",

    //Charts
    PointsActivityChart: "api/events",
    EndpointsActivityChart: "api/endpoints/flow/chart-data",
    EndpointsEvents: "api/endpoints/flow/events",
    EndpointsMetricsChart: "api/endpoints/metrics",
    EndpointsDiagnosticsChart: "api/endpoints/diagnostics",
    EndpointsLastSeen: "api/endpoints/last-seen",
    EndpointsEventsBff: "web/v1/endpoint/events/flow",
    EndpointsEventsState: "web/v1/endpoints/events/state",
    EndpointsEventsStateChartData: "web/v1/endpoints/events/state/chart-data",
    DeviceInfo: "web/v1/devices/events/device-info",

    //Integration Base
    ImportXlsx: "api/import/xlsx",
    ExportXlsx: "api/export/xlsx",
    ExportXlsxTemplate: "api/export/xlsx/template",
    ExportXlsxTemplateCUID: "api/export/xlsx/cuid-template",

    //Schedules Base
    Schedules: "api/schedules",

    //Actions Base
    Actions: "api/report/compliance/site/actions",
    EventsPerAction: "api/report/compliance/site/action/events",

    //Tasks Base
    Tasks: "api/tasks",

    //Events Base
    Events: "api/events",

    //System Base
    AlertJobs: "/web/v1/alerts/hangfire",
    WorkOrderJobs: "/web/v1/work-order/hangfire",

    //Reports Base
    ReportCompliance: "/api/report/compliance/site/actions",
    ReportSchedules: "/api/report/schedules",
    PendingActionsReport: "/api/report/compliance/site/actions/pending",
    /** POST — Work orders compliance actions for site (backend route keeps `/gantt` for now) */
    ReportWorkOrdersActions: "api/report/compliance/site/actions/gantt",
    /** PATCH — Assign/clear Cause Codes on work order actions (empty string clears) */
    ReportWorkOrdersCauseCodes: "api/report/compliance/site/actions/cause-codes",
    ReportSendEmail: "api/report/email/compliance",
    /** POST — Generate the standard PDF report; responds with PDF bytes */
    ReportEndpointStandard: "api/report/endpoint/standard",

    //Auth-Tokens
    AuthTokens: "api/settings/auth-token",

    //Dashboard
    Dashboard: "web/v1/dashboard",
    Dashboards: "web/v1/dashboards",
    AccountSettings: "web/v1/settings/account",

    //Compliance cache (SuperAdmin only)
    ComplianceCache: "web/v1/compliance-cache",

    //Super Administration
    SuperAdministration : "/admin",
    SuperAdministrationRoutes: {
        GetAllSites: "/sites",
        CreateSite: "/sites",
        UpdateSite: "/sites",
        GetAllUsers: "/users",
        GetAllRoles : "/roles",
        PostInviteUser: "/users/invite",
        PostResendUserInvite: "/users/resendInvite",
        DeleteUser : "/users/delete"
    },

    //Site Administration
    SiteAdministration: "/site",
    SiteAdministrationRoutes: {
        GetAllUsers: "/users",
        GetAllRoles : "/roles",
        PostInviteUser: "/users/invite",
        PostResendUserInvite: "/users/resendInvite",
        DeleteUser : "/users/delete"
    }

}